import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';

const TrainingCollectif = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [individualPrice, setIndividualPrice] = useState('');
    const [groupOffer, setGroupOffer] = useState('');
    const token = sessionStorage.getItem('token');


    useEffect(() => {
        setIndividualPrice(training.groupes || '');
        setGroupOffer(training.groupesMax || '');
    }, [training.groupes, training.groupesMax]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handlePriceChange = (event) => {
        setIndividualPrice(event.target.value);
    };

    const handleGroupOfferChange = (event) => {
        setGroupOffer(event.target.value);
    };

    const handleSaveClick = async () => {
        training.groupes = individualPrice;
        training.groupesMax = groupOffer !== '' ? groupOffer : null; // ou juste groupOffer si tu veux enregistrer une chaîne vide


        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        window.location.reload();
        setEditMode(false);
    };

    return (
        <div className="section-content">
            {editMode ? (
                <div>
                    <label>Nombre de paticipants minimales :</label>
                    <input
                        type="number"
                        value={individualPrice}
                        onChange={handlePriceChange}
                        style={{ width: '100%' }}
                    />
                    <label>Nombre de paticipants maximales :</label>
                    <input
                        type="number"
                        value={groupOffer}
                        onChange={handleGroupOfferChange}
                        style={{ width: '100%' }}
                    />
                </div>
            ) : (
                <div>
                    <p>
                        {training.groupes !== null && training.groupesMax !== undefined ? (
                            <> Formation réalisée en parcours collectif d’un groupe de {individualPrice} à {groupOffer} participants.</>
                        ) : (
                            <> Groupes à renseigné </>
                        )}
                    </p>
                </div>
            )}

            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingCollectif;